/**
 * Strings only defined in client
 **/

export const OTHER = 'OTHER'

export const WRONG_PLATFORM = 'WRONG_PLATFORM'

// SDK methods called in wrong order
export const NOT_INITIALIZED = 'NOT_INITIALIZED'
export const NO_USER_AUTHENTICATED = 'NO_USER_AUTHENTICATED'

// solely depending on status code
export const CONNECTION_FAILED = 'CONNECTION_FAILED'
export const SERVER_ERROR = 'SERVER_ERROR'
export const UNAUTHORIZED = 'UNAUTHORIZED'
export const FORBIDDEN = 'FORBIDDEN'

// relative to BatchUploader
export const BATCH_IS_BEING_SENT = 'BATCH_IS_BEING_SENT'
export const BATCH_IS_ALREADY_SENT = 'BATCH_IS_ALREADY_SENT'

/**
 * Synchronized with backend
 * https://github.com/purchease/purchease/blob/9b6c4475d0a2c357888cfa161dfb3cbae0ee5e76/lib/api/error_codes.rb#L1
 **/

export const INVALID_PARAMETER = 'invalid_parameter' // => options must have (parameter / reason)

// relative to user sign up
export const LEGACY_PARTNER = 'legacy_partner'

// relative to receipt create v2
export const RECEIPT_NOT_REPLACEABLE = 'receipt_not_replaceable'

// relative to transfer payments
export const MISSING_PAYMENT_INFORMATION = 'missing_payment_information'
export const EMPTY_POT = 'empty_pot'
// export const NEGATIVE_BALANCE_ON_CARD = 'negative_balance_on_card'
// export const TRANSFERTS_BLOCKED = 'transfers_blocked'
// export const RECEIPT_WAITING_FOR_REVIEW = 'receipt_waiting_for_review'

// relative to login/signup/resetPassword
export const UNKNOWN_EMAIL = 'unknown_email'
export const WRONG_PASSWORD = 'wrong_password'
export const ACCOUNT_ALREADY_EXISTS = 'account_already_exists'

// relative to loyalty catalog
export const NOT_BUYABLE = 'not_buyable'
export const NOT_ENOUGH_POINTS = 'not_enough_points'
export const NOT_CANCELABLE = 'not_cancelable'
